var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-button",
        {
          staticClass: "guide-btn",
          attrs: {
            type: "primary",
            disabled: _vm.isConnect,
            loading: _vm.loading,
          },
          on: {
            click: function ($event) {
              return _vm.connectMetaMask()
            },
          },
        },
        [
          _c("img", {
            staticClass: "mm-logo",
            attrs: { src: require("@/assets/logo/mm-logo.png") },
          }),
          _vm._v("\n    " + _vm._s(_vm.btnText) + "\n  "),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }